import { makeApiActionCreatorV3 } from '@actions/utils';

import * as api from '../api/taxingUnit';

const namespace = 'ASSESSMENT';

export const TAXING_UNITS_FETCH_START = `${namespace}/TAXING_UNITS_FETCH_START`;
export const TAXING_UNITS_FETCH_SUCCESS = `${namespace}/TAXING_UNITS_FETCH_SUCCESS`;
export const TAXING_UNITS_FETCH_ERROR = `${namespace}/TAXING_UNITS_FETCH_ERROR`;

export const TAXING_UNIT_FETCH_START = `${namespace}/TAXING_UNIT_FETCH_START`;
export const TAXING_UNIT_FETCH_SUCCESS = `${namespace}/TAXING_UNIT_FETCH_SUCCESS`;
export const TAXING_UNIT_FETCH_ERROR = `${namespace}/TAXING_UNIT_FETCH_ERROR`;

export const TAXING_UNIT_TYPES_FETCH_START = `${namespace}/TAXING_UNIT_TYPES_FETCH_START`;
export const TAXING_UNIT_TYPES_FETCH_SUCCESS = `${namespace}/TAXING_UNIT_TYPES_FETCH_SUCCESS`;
export const TAXING_UNIT_TYPES_FETCH_ERROR = `${namespace}/TAXING_UNIT_TYPES_FETCH_ERROR`;

export const TAXING_UNIT_FUND_TYPES_FETCH_START = `${namespace}/TAXING_UNIT_FUND_TYPES_FETCH_START`;
export const TAXING_UNIT_FUND_TYPES_FETCH_SUCCESS = `${namespace}/TAXING_UNIT_FUND_TYPES_FETCH_SUCCESS`;
export const TAXING_UNIT_FUND_TYPES_FETCH_ERROR = `${namespace}/TAXING_UNIT_FUND_TYPES_FETCH_ERROR`;

export const TAXING_UNIT_EPTS_TYPES_FETCH_START = `${namespace}/TAXING_UNIT_EPTS_TYPES_FETCH_START`;
export const TAXING_UNIT_EPTS_TYPES_FETCH_SUCCESS = `${namespace}/TAXING_UNIT_EPTS_TYPES_FETCH_SUCCESS`;
export const TAXING_UNIT_EPTS_TYPES_FETCH_ERROR = `${namespace}/TAXING_UNIT_EPTS_TYPES_FETCH_ERROR`;

export const CREATE_TAXING_UNIT_START = `${namespace}/CREATE_TAXING_UNIT_START`;
export const CREATE_TAXING_UNIT_SUCCESS = `${namespace}/CREATE_TAXING_UNIT_SUCCESS`;
export const CREATE_TAXING_UNIT_ERROR = `${namespace}/CREATE_TAXING_UNIT_ERROR`;

export const UPDATE_TAXING_UNIT_START = `${namespace}/UPDATE_TAXING_UNIT_START`;
export const UPDATE_TAXING_UNIT_SUCCESS = `${namespace}/UPDATE_TAXING_UNIT_SUCCESS`;
export const UPDATE_TAXING_UNIT_ERROR = `${namespace}/UPDATE_TAXING_UNIT_ERROR`;

export const DELETE_TAXING_UNIT_START = `${namespace}/DELETE_TAXING_UNIT_START`;
export const DELETE_TAXING_UNIT_SUCCESS = `${namespace}/DELETE_TAXING_UNIT_SUCCESS`;
export const DELETE_TAXING_UNIT_ERROR = `${namespace}/DELETE_TAXING_UNIT_ERROR`;

export const SELECT_TAXING_UNIT = `${namespace}/SELECT_TAXING_UNIT`;

export const fetchTaxingUnits = makeApiActionCreatorV3(
  api.fetchTaxingUnits,
  TAXING_UNITS_FETCH_START,
  TAXING_UNITS_FETCH_SUCCESS,
  TAXING_UNITS_FETCH_ERROR,
);

export const fetchTaxingUnit = makeApiActionCreatorV3(
  api.fetchTaxingUnit,
  TAXING_UNIT_FETCH_START,
  TAXING_UNIT_FETCH_SUCCESS,
  TAXING_UNIT_FETCH_ERROR,
);

export const fetchTaxingUnitTypes = makeApiActionCreatorV3(
  api.fetchTaxingUnitTypes,
  TAXING_UNIT_TYPES_FETCH_START,
  TAXING_UNIT_TYPES_FETCH_SUCCESS,
  TAXING_UNIT_TYPES_FETCH_ERROR,
);

export const fetchTaxingUnitFundTypes = makeApiActionCreatorV3(
  api.fetchTaxingUnitFundTypes,
  TAXING_UNIT_FUND_TYPES_FETCH_START,
  TAXING_UNIT_FUND_TYPES_FETCH_SUCCESS,
  TAXING_UNIT_FUND_TYPES_FETCH_ERROR,
);

export const fetchTaxingUnitEPTSTypes = makeApiActionCreatorV3(
  api.fetchTaxingUnitEPTSTypes,
  TAXING_UNIT_EPTS_TYPES_FETCH_START,
  TAXING_UNIT_EPTS_TYPES_FETCH_SUCCESS,
  TAXING_UNIT_EPTS_TYPES_FETCH_ERROR,
);

export const createTaxingUnit = makeApiActionCreatorV3(
  api.createTaxingUnit,
  CREATE_TAXING_UNIT_START,
  CREATE_TAXING_UNIT_SUCCESS,
  CREATE_TAXING_UNIT_ERROR,
);

export const updateTaxingUnit = makeApiActionCreatorV3(
  api.updateTaxingUnit,
  UPDATE_TAXING_UNIT_START,
  UPDATE_TAXING_UNIT_SUCCESS,
  UPDATE_TAXING_UNIT_ERROR,
);

export const deleteTaxingUnit = makeApiActionCreatorV3(
  api.deleteTaxingUnit,
  DELETE_TAXING_UNIT_START,
  DELETE_TAXING_UNIT_SUCCESS,
  DELETE_TAXING_UNIT_ERROR,
);

export const FETCH_TAXING_UNIT_REVISION_HISTORY_START = `${namespace}/FETCH_TAXING_UNIT_REVISION_HISTORY_START`;
export const FETCH_TAXING_UNIT_REVISION_HISTORY_SUCCESS = `${namespace}/FETCH_TAXING_UNIT_REVISION_HISTORY_SUCCESS`;
export const FETCH_TAXING_UNIT_REVISION_HISTORY_ERROR = `${namespace}/FETCH_TAXING_UNIT_REVISION_HISTORY_ERROR`;

export const fetchTaxingUnitRevisionHistory = makeApiActionCreatorV3(
  api.fetchTaxingUnitRevisionHistory,
  FETCH_TAXING_UNIT_REVISION_HISTORY_START,
  FETCH_TAXING_UNIT_REVISION_HISTORY_SUCCESS,
  FETCH_TAXING_UNIT_REVISION_HISTORY_ERROR,
);


export const FETCH_TAXING_UNIT_VERSION_REVISION_HISTORY_START = `${namespace}/FETCH_TAXING_UNIT_VERSION_REVISION_HISTORY_START`;
export const FETCH_TAXING_UNIT_VERSION_REVISION_HISTORY_SUCCESS = `${namespace}/FETCH_TAXING_UNIT_VERSION_REVISION_HISTORY_SUCCESS`;
export const FETCH_TAXING_UNIT_VERSION_REVISION_HISTORY_ERROR = `${namespace}/FETCH_TAXING_UNIT_VERSION_REVISION_HISTORY_ERROR`;

export const fetchTaxingUnitVersionRevisionHistory = makeApiActionCreatorV3(
  api.fetchTaxingUnitVersionRevisionHistory,
  FETCH_TAXING_UNIT_VERSION_REVISION_HISTORY_START,
  FETCH_TAXING_UNIT_VERSION_REVISION_HISTORY_SUCCESS,
  FETCH_TAXING_UNIT_VERSION_REVISION_HISTORY_ERROR,
);

export const FETCH_TAXING_UNIT_NOTES_START = `${namespace}/FETCH_TAXING_UNIT_NOTES_START`;
export const FETCH_TAXING_UNIT_NOTES_SUCCESS = `${namespace}/FETCH_TAXING_UNIT_NOTES_SUCCESS`;
export const FETCH_TAXING_UNIT_NOTES_ERROR = `${namespace}/FETCH_TAXING_UNIT_NOTES_ERROR`;

export const fetchTaxingUnitNotes = makeApiActionCreatorV3(
  api.fetchTaxingUnitNotes,
  FETCH_TAXING_UNIT_NOTES_START,
  FETCH_TAXING_UNIT_NOTES_SUCCESS,
  FETCH_TAXING_UNIT_NOTES_ERROR,
);

export const CREATE_TAXING_UNIT_NOTES_START = `${namespace}/CREATE_TAXING_UNIT_NOTES_START`;
export const CREATE_TAXING_UNIT_NOTES_SUCCESS = `${namespace}/CREATE_TAXING_UNIT_NOTES_SUCCESS`;
export const CREATE_TAXING_UNIT_NOTES_ERROR = `${namespace}/CREATE_TAXING_UNIT_NOTES_ERROR`;

export const createTaxingUnitNote = makeApiActionCreatorV3(
  api.createTaxingUnitNote,
  CREATE_TAXING_UNIT_NOTES_START,
  CREATE_TAXING_UNIT_NOTES_SUCCESS,
  CREATE_TAXING_UNIT_NOTES_ERROR,
);

export const UPDATE_TAXING_UNIT_NOTES_START = `${namespace}/UPDATE_TAXING_UNIT_NOTES_START`;
export const UPDATE_TAXING_UNIT_NOTES_SUCCESS = `${namespace}/UPDATE_TAXING_UNIT_NOTES_SUCCESS`;
export const UPDATE_TAXING_UNIT_NOTES_ERROR = `${namespace}/UPDATE_TAXING_UNIT_NOTES_ERROR`;

export const updateTaxingUnitNote = makeApiActionCreatorV3(
  api.updateTaxingUnitNote,
  UPDATE_TAXING_UNIT_NOTES_START,
  UPDATE_TAXING_UNIT_NOTES_SUCCESS,
  UPDATE_TAXING_UNIT_NOTES_ERROR,
);

export const DELETE_TAXING_UNIT_NOTES_START = `${namespace}/DELETE_TAXING_UNIT_NOTES_START`;
export const DELETE_TAXING_UNIT_NOTES_SUCCESS = `${namespace}/DELETE_TAXING_UNIT_NOTES_SUCCESS`;
export const DELETE_TAXING_UNIT_NOTES_ERROR = `${namespace}/DELETE_TAXING_UNIT_NOTES_ERROR`;

export const deleteTaxingUnitNote = makeApiActionCreatorV3(
  api.deleteTaxingUnitNote,
  DELETE_TAXING_UNIT_NOTES_START,
  DELETE_TAXING_UNIT_NOTES_SUCCESS,
  DELETE_TAXING_UNIT_NOTES_ERROR,
);

export function selectTaxingUnit(taxingUnit) {
  return async dispatch => {
    dispatch({ type: SELECT_TAXING_UNIT, data: taxingUnit });
  };
}
